import { render, staticRenderFns } from "./OrganizationPress.vue?vue&type=template&id=c16d657a&"
import script from "./OrganizationPress.vue?vue&type=script&lang=js&"
export * from "./OrganizationPress.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationPress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports